import { createContext } from "react";

const TypeContext = createContext({});

export default TypeContext;